import { Page } from "table-engine";
import { topicTable } from "./config/tables";

export default function TableEngine() {
    return <Page table={topicTable} />;
}
